import React from 'react';

const IntroScreen = ({ onStart }) => {
  return (
    <div className="selection-screen fade-in">
      <div className='instruction-text'>
        <p className='text-primary instruction-title mb-2'>Welcome to AI Mentor!</p>
        
        <div className="intro-description">
          <p>
            Connect with digital avatars of the world's greatest minds. 
            Get personalized advice, discuss complex topics, and accelerate your growth through conversations.
          </p>
          
          <div style={{ marginTop: '15px', padding: '12px', background: '#f8f9fa', borderRadius: '8px', borderLeft: '3px solid #0d6efd' }}>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#495057', lineHeight: '1.5' }}>
              <strong>More than just a chat:</strong> To help you apply what you learn, your mentor will assign <strong>actionable weekly tasks</strong>. 
              Completing these tasks is key to turning advice into real-world progress.
            </p>
          </div>
          
        </div>

        <p className="mt-3 mb-4" style={{ fontSize: '0.9rem', color: '#555' }}>
          💡 <strong>Tip:</strong> Be ready to share your <strong>professional background</strong> with your mentor to get advice tailored specifically to your career.
        </p>

        <div className="rule-box">
          <div className="rule-text">
            <p style={{ marginBottom: '8px' }}>
              <strong>⚠️ Usage Limits:</strong>
            </p>
            <ul style={{ textAlign: 'left', paddingLeft: '20px', margin: 0, color: '#333' }}>
                <li style={{ marginBottom: '6px' }}>
                    You have <strong>4 mentor sessions per week</strong>. Use them wisely!
                </li>
                <li>
                    Real growth takes time. You can only <strong>switch mentors once every 2 months</strong>.
                </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Proceed */}
      <div className="options-grid" style={{ display: 'flex', justifyContent: 'center' }}>
        <button 
          className="start-btn" 
          onClick={onStart}
        >
          I Understand, Let's Start
        </button>
      </div>

    </div>
  );
};

export default IntroScreen;